import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { useScenarioStore } from '../../pages/scenario-modeling/scenario-modeling.store';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';

interface LiquidityGraphData {
  effectiveLiquidityProceeds: number;
  investment: number;
  name: string;
  roi: number;
  stakeholder: { id: string };
}

export const useLiquidityGraphData = () => {
  const queryClient = useQueryClient();
  const { scenarioId } = useScenarioStore();

  const { data = [], isLoading } = useAppQuery<LiquidityGraphData[]>({
    queryKey: [QueryKey.LIQUIDITY_GRAPH_DATA, scenarioId],
    queryFn: () =>
      ApiService.get({
        endpoint: BackendRoute.SCENARIOS,
        routePath: [scenarioId, 'cap-table', 'liquidity-graph'],
      }),
    refetchOnWindowFocus: false,
    enabled: !!scenarioId,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.LIQUIDITY_GRAPH_DATA] });
  }, [queryClient]);

  return {
    invalidateQuery,
    data,
    isLoading,
  };
};
